import React from 'react'
// highlight-next-line
import { Route, Routes } from 'react-router'

import { APP_PATH } from '../../../ui/enums/appPath.enum'
import ApiDocumentation from '../../../ui/modules/apiDocumentation/apiDocumentation'
import Cgu from '../../../ui/modules/cgu/cgu'
import Dashboard from '../../../ui/modules/dashboard/dashboard'
import Documents from '../../../ui/modules/documents/documents'
import { Downloads } from '../../../ui/modules/downloads/downloads'
import PlantInfos from '../../../ui/modules/plantInfos/plantInfos'
import PlantSelect from '../../../ui/modules/plantSelect/plantSelect'

export const Miss: React.FC = () => {
  return <div>Miss</div>
}

const Router: React.FC = () => (
  // highlight-start
  <Routes>
    <Route index path={APP_PATH.HOME} element={<Dashboard />} />
    <Route path={APP_PATH.DOCUMENTS} element={<Documents />} />
    <Route path={APP_PATH.PLANT_SELECT} element={<PlantSelect />} />
    <Route path={APP_PATH.PLANT_INFOS} element={<PlantInfos />} />
    <Route path={APP_PATH.DOWNLOAD} element={<Downloads />} />
    <Route path={APP_PATH.CGU} element={<Cgu />} />
    <Route path={APP_PATH.API_DOCUMENTATION} element={<ApiDocumentation />} />
    <Route path="*" element={<Miss />} />
  </Routes>
  // highlight-end
)

export default Router
